import React, { useState, useEffect } from "react";
import { retailerService } from "../../Services";
import ReactPaginate from "react-paginate";
import Loader from "../../Components/Loader";
import { Modal, Form, Badge, Button } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import moment from "moment";

export const SaasRetailerList = () => {
  const [listData, setListData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);

  // Modals state
  const [isRejectOpen, setIsRejectOpen] = useState(false);
  const [isVerifyOpen, setIsVerifyOpen] = useState(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  
  const [rejectionReason, setRejectionReason] = useState("");
  const [selectedRetailer, setSelectedRetailer] = useState(null);

  useEffect(() => {
    getItemList();
    // eslint-disable-next-line
  }, [currentPage]);

  const getItemList = () => {
    let param = { ...pagination, page: currentPage, is_saas: "true" };
    if (pagination.search) {
      param["page"] = 1;
    }
    
    setLoader(true);
    retailerService.getRetailer(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setListData(res.data);
        setPagination({ ...pagination, ...res.pagination });
      } else {
        setLoader(false);
      }
    }).catch(() => {
        setLoader(false);
    });
  };

  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const handleVerify = () => {
    let postData = {
      id: selectedRetailer._id,
      retailer_status: "ACTIVE"
    };
    
    setLoader(true);
    retailerService.updateRetailerStatus(postData).then((res) => {
      setLoader(false);
      if (res.status) {
        toast.success("Retailer verified successfully and email sent.");
        setIsVerifyOpen(false);
        setSelectedRetailer(null);
        getItemList();
      } else {
        toast.error(res.message || "Failed to verify retailer");
      }
    });
  };

  const handleReject = () => {
    if (!rejectionReason.trim()) {
      toast.error("Please provide a rejection reason.");
      return;
    }

    let postData = {
      id: selectedRetailer._id,
      retailer_status: "REJECTED",
      rejection_reason: rejectionReason
    };
    
    setLoader(true);
    retailerService.updateRetailerStatus(postData).then((res) => {
      setLoader(false);
      if (res.status) {
        toast.success("Retailer rejected and email sent.");
        setIsRejectOpen(false);
        setRejectionReason("");
        setSelectedRetailer(null);
        getItemList();
      } else {
        toast.error(res.message || "Failed to reject retailer");
      }
    });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title mb-4">SaaS Retailer Approvals</h4>
            <div className="mb-3 row me-1">
              <div className="col-12">
                <div className="input-group w-25">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search by name or email..."
                    onChange={(e) =>
                      setPagination({ ...pagination, search: e.target.value })
                    }
                    onKeyPress={(e) => e.key === "Enter" && getItemList()}
                    onKeyUp={(e) =>
                      e.key === "Backspace" &&
                      pagination.search.length <= 0 &&
                      getItemList()
                    }
                  />
                  <div className="input-group-append">
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={() => getItemList()}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-striped table-hover mb-0">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Company Name</th>
                    <th>Email</th>
                    <th>Plan</th>
                    <th>Payment Status</th>
                    <th>Approval Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {!loader ? (
                    listData.length > 0 ? (
                      listData.map((item, index) => (
                        <tr key={index}>
                          <td>
                            {(pagination.page - 1) * pagination.limit +
                              index +
                              1}
                          </td>
                          <td>{item.retailer_name}</td>
                          <td>{item.retailer_email}</td>
                          <td>
                            <Badge bg="info">{item.subscription_plan}</Badge>
                          </td>
                          <td>
                            {item.subscription_status === 'ACTIVE' ? (
                                <Badge bg="success">Paid</Badge>
                            ) : (
                                <Badge bg="warning">{item.subscription_status}</Badge>
                            )}
                          </td>
                          <td>
                            {item.retailer_status === 'ACTIVE' ? (
                                <Badge bg="success">Approved</Badge>
                            ) : item.retailer_status === 'REJECTED' ? (
                                <Badge bg="danger">Rejected</Badge>
                            ) : (
                                <Badge bg="warning">Pending</Badge>
                            )}
                          </td>
                          <td>
                            <button
                                className="btn btn-sm btn-primary me-2"
                                onClick={() => {
                                    setSelectedRetailer(item);
                                    setIsViewOpen(true);
                                }}
                            >
                                View Details
                            </button>
                            {item.retailer_status !== 'ACTIVE' && (
                                <button
                                    className="btn btn-sm btn-success me-2"
                                    onClick={() => {
                                        setSelectedRetailer(item);
                                        setIsVerifyOpen(true);
                                    }}
                                >
                                    Verify
                                </button>
                            )}
                            {item.retailer_status !== 'REJECTED' && (
                                <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => {
                                        setSelectedRetailer(item);
                                        setRejectionReason("");
                                        setIsRejectOpen(true);
                                    }}
                                >
                                    Reject
                                </button>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No SaaS Retailers Found
                        </td>
                      </tr>
                    )
                  ) : (
                    <tr>
                      <td colSpan="7">
                        <Loader />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="pagination-wrap">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(
                    pagination.totalRecord / pagination.limit
                  )}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={2}
                  onPageChange={onPageChangeEvent}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                  forcePage={currentPage - 1}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Verify Modal */}
      <Modal show={isVerifyOpen} onHide={() => setIsVerifyOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Verify SaaS Retailer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to approve and verify <strong>{selectedRetailer?.retailer_name}</strong>?</p>
          <p className="text-muted">An approval email will be sent to {selectedRetailer?.retailer_email}.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setIsVerifyOpen(false)}>Cancel</Button>
          <Button variant="success" onClick={handleVerify}>Verify</Button>
        </Modal.Footer>
      </Modal>

      {/* Reject Modal */}
      <Modal show={isRejectOpen} onHide={() => setIsRejectOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Reject SaaS Retailer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
              <Form.Label>Reason for Rejection <span className="text-danger">*</span></Form.Label>
              <Form.Control 
                  as="textarea" 
                  rows={4}
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  placeholder="Please explain why the retailer is being rejected. This will be sent to the retailer via email."
              />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setIsRejectOpen(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleReject}>Reject</Button>
        </Modal.Footer>
      </Modal>

      {/* View Details Modal */}
      <Modal show={isViewOpen} onHide={() => setIsViewOpen(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Retailer Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRetailer && (
              <div>
                  <h5 className="mb-3 border-bottom pb-2">Company Information</h5>
                  <div className="row mb-3">
                      <div className="col-md-6">
                          <strong>Company Name:</strong> {selectedRetailer.retailer_name}
                      </div>
                      <div className="col-md-6">
                          <strong>Contact Name:</strong> {selectedRetailer.contact_name}
                      </div>
                  </div>
                  <div className="row mb-3">
                      <div className="col-md-6">
                          <strong>Email:</strong> {selectedRetailer.retailer_email}
                      </div>
                      <div className="col-md-6">
                          <strong>Phone:</strong> {selectedRetailer.phone_number}
                      </div>
                  </div>
                  <div className="row mb-3">
                      <div className="col-md-12">
                          <strong>Address:</strong> {selectedRetailer.address}, {selectedRetailer.city}, {selectedRetailer.state}, {selectedRetailer.country}
                      </div>
                  </div>

                  <h5 className="mb-3 border-bottom pb-2 mt-4">Subscription Details</h5>
                  <div className="row mb-3">
                      <div className="col-md-6">
                          <strong>Plan:</strong> {selectedRetailer.subscription_plan}
                      </div>
                      <div className="col-md-6">
                          <strong>Status:</strong> {selectedRetailer.subscription_status}
                      </div>
                  </div>

                  <h5 className="mb-3 border-bottom pb-2 mt-4">Uploaded Documents</h5>
                  {selectedRetailer.documents && selectedRetailer.documents.length > 0 ? (
                      <ul className="list-group">
                          {selectedRetailer.documents.map((doc, idx) => (
                              <li key={idx} className="list-group-item d-flex justify-content-between align-items-center">
                                  {doc.document_name || (typeof doc === 'string' ? doc.split('/').pop() : 'Document')}
                                  <a 
                                    href={doc.file_path && doc.file_path.startsWith('http') ? `${process.env.REACT_APP_API_BASEURL || 'https://dev.world2doorcargo.com/api'}/retailer/document/view?key=${encodeURIComponent(doc.file_path)}` : (doc.file_path || doc)} 
                                    target="_blank" 
                                    rel="noreferrer" 
                                    className="btn btn-sm btn-primary"
                                  >
                                      View / Download
                                  </a>
                              </li>
                          ))}
                      </ul>
                  ) : (
                      <p className="text-muted">No documents uploaded.</p>
                  )}
                  
                  {selectedRetailer.rejection_reason && (
                      <div className="mt-4 alert alert-danger">
                          <strong>Rejection Reason:</strong> {selectedRetailer.rejection_reason}
                      </div>
                  )}
              </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setIsViewOpen(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};
